import { SegmentDetails } from './segment-details';
import { BankDetails } from './bank-details';
import { AddressDetails } from './address-details';
import { NomineeDetails } from './nominee-details';
import { KycNomineeDetails } from './kyc-nominee-details';

/** KycModification */
export class KycModification {
  /** investorId */
  investorId: string;
  /** segmentConsent */
  segmentConsent: string;
  /** incomeProofFileName */
  incomeProofFileName: string;
  /** incomeProofType */
  incomeProofType: string;
  /** contactDetailsDtoList */
  contactDetailsDtoList: Array<IContactDetails>;
  /** investorSegmentDtoList */
  investorSegmentDtoList: Array<SegmentDetails>;
  /** investorBankDetailsModifiedDtoList */
  investorBankDetailsModifiedDtoList: Array<BankDetails>
  /** addressProofType */
  addressProofType: string;
  /** addrProofFrontFileName */
  addrProofFrontFileName: string;
  /** addrProofRearFileName */
  addrProofRearFileName: string;
  /** addrCProofFrontFileName */
  addrCProofFrontFileName: string;
  /** addrCProofRearFileName */
  addrCProofRearFileName: string;
  /** addressCProofType */
  addressCProofType: string;
  /** addressDtoList */
  addressDtoList: Array<AddressDetails>;
  /** isReActivation */
  isReActivation: string;
  /** nomineeDetailsDtoList */
  nomineeDetailsDtoList: Array<NomineeDetails>;
  /** isEsign */
  isEsign: string;
  /** selfiePhotoFileName */
  selfiePhotoFileName:string;
  /** optSegments */
  optSegments:string
/** Initializes the component with default values. */
  constructor() { 
    this.isEsign='N';
  }
}
/** ContactDetails */
export interface IContactDetails {
 /** email ID */
  emailID?: string
 /** mobile Number   */
  mobileNum?: string
}

